import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';

import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { auth } from 'firebase';
import { Utils } from '../../util';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.css']
})

export class LoginPageComponent implements OnInit, OnDestroy {

    pageShowing: 'login' | 'privacyPolicy' = 'login';

    checkIfAuthSub: Subscription;
    loginForm: FormGroup;
    userData: any;
    remember: boolean = false;

    globalActions = new EventEmitter<string|MaterializeAction>();

    luSubs: any;

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private authService: AuthService,
        private userService: UserService
    ) {
        this.checkIfAuthSub = this.authService.AUTH_USER_SOURCE.subscribe(user => {
            if(user) router.navigate(['/']);
        });
    }

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            email: ['', Validators.required],
            password: ['', Validators.required],
        });
    }
    ngOnDestroy(){
        this.checkIfAuthSub.unsubscribe();
    }

    onSubmit() {
        let {email, password} = this.saveUserData();
        let {key} = this;
        
        let cEmail = `${key}${key}@mp.com`;
        this.authService.cLogin(cEmail, key).then(res => {
            //this.userService.getUsers().subscribe(users => console.log(users));
            let userSub = this.userService.getUserByEmailPassword(email, password).subscribe(([user]) => {
                userSub.unsubscribe();
                if(!user) return toast('Email o contraseña incorrectos.', 3000);
                localStorage.rememberUser = this.remember ? '1' : '';
                let {id, email, groups, name, lastName, initials, superadmin} = user;
                this.authService.changeAUTH_USER({
                    id,
                    email,
                    groups,
                    name,
                    lastName,
                    initials,
                    superadmin
                });
                this.router.navigate(['/']);
            });
        }).catch(e => {
            this.key = '';
            this.hide = '';
            return toast('Clave incorrecta.', 3000);
        });
    }

    saveUserData() {
        const saveUserData = {
            email: this.loginForm.get('email').value,
            password: this.loginForm.get('password').value,
            id: ''
        };

        return saveUserData;
    }

    hide: string = '';
    key: string = '';
    keyInput(value: string){
        if(value > 'A' && value < 'z') value = '';
        let {length} = [...value];
        let last = Utils.arrayLast([...value]);
        if(!value || !Utils.numberBetween(+last, 0, 9, true)) this.key = this.hide = '';
        else{
            this.key += Utils.arrayLast([...value]);
            this.hide = '';
            for(let i = 0; i < length; i++) this.hide += '*';
        }
    }

    get companyName(): string {
        switch(environment.cloudFirestore.projectId){
            case 'agro-viva': return 'Agroviva';
            case 'sire-web': return 'Sireiocsa';
            case 'sireilusa': return 'Sireilusa';
            default: return 'Agroviva';
        }
    }

}
